goog.provide('el8.ptdata.prenatalFlowsheets');

goog.require('el8.model.base');
goog.require('el8.appservice.notifier');
goog.require('el8.template.ptdata.prenatalFlowsheets');
goog.require('el8.ptdata.model.prenatalFlowsheetVisitMeasurement');
goog.require('el8.ptdata.prenatalFlowsheetVisitMeasurements');


el8.ptdata.prenatalFlowsheets = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeDocument();

    _class.addStringProperty('name', true);
    _class.addStringProperty('weightPrepreg', true);
    _class.addDate('endDate', true);
    _class.addProperty('visitMeasurements', true, []);
    _class.addDate('edd', true);
    _class.addBoolean('eddFinal', true);
    _class.addStringProperty('eddNotes', true);
    _class.addDate('lmpDate', true);
    _class.addStringProperty('bpSPrepreg', true);
    _class.addStringProperty('bpDPrepreg', true);
    _class.addStringProperty('synopsis', true);

    _class.prototype.populate = function(spec) {
        spec = spec || {};
        this.parent.populate.call(this, spec);

        var visitMeasurements = [];
        _.each(spec.visit_measurements, function (vm) {
            visitMeasurements.push(el8.ptdata.model.prenatalFlowsheetVisitMeasurement(vm));
        });

        this.setVisitMeasurements(visitMeasurements);
    };

    _class.prototype.print = function() {
        var printPath = el8.service.urls.get('printPrenatalFlowsheet', [this]);
        if (el8Globals.APP === 'chart') {
            el8.appchart.printService.open({
                url: printPath,
                attachmentId: this.getId()
            });
        } else {
            window.open(printPath);
        }
    };

    _class.prototype.deleteFlowsheet = function() {
        // This will delete all the measurements server-side
        el8.ptdata.prenatalFlowsheets.deleteItem(this);

        for (var i = 0; i < this.getVisitMeasurements().length; i++) {
            el8.ptdata.prenatalFlowsheetVisitMeasurements.remove(this.getVisitMeasurements()[i]);
        }
    };

    _class.prototype.hasDraft = function() {
        var vms = _.sortBy(this.getVisitMeasurements(),
                                    function(item) { return item.getDate().getTime(); });

        if (vms.length && !_.last(vms).isSignedOff()) { return true; }
        return false;
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        // report attachment helper (could also use last measurement date)
        mapped['eddFinal'] = mapped.isEddFinal;
        mapped['documentDate'] = mapped.createDate;
        mapped['hasDraft'] = this.hasDraft();
        return mapped;
    };

    /**
     * Entity Set
     */
    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('prenatalFlowsheets'); },
        observable: true,
        saveFn: function(item, successCallbackFn) {
            el8.appservice.notifier.notify('Prenatal flowsheet being saved...');
            var saved = false;
            $.el8_ajax({
                url: el8.service.urls.get('prenatalFlowsheets', [item]),
                type: 'POST',
                async: false,
                data: JSON.stringify(item.asMap(true)),
                success: function(data) {
                    saved = true;
                    item.populate(data);
                    if (successCallbackFn) { successCallbackFn(item); }
                    el8.appservice.notifier.notify('Prenatal flowsheet saved.');
                }
            });
            // Can only do this because async = false;
            return saved ? item : null;
        },
        deleteFn: function(item, successCallbackFn) {
            el8.appservice.notifier.notify('Prenatal flowsheet being deleted...');
            $.el8_ajax({
                url: el8.service.urls.get('prenatalFlowsheets', [item]),
                type: 'DELETE',
                success: function(data) {
                    for (var i = 0; i < item.getVisitMeasurements().length; i++) {
                        el8.appchart.mainFeeds.chart.remove(item.getVisitMeasurements()[i].getId());
                    }
                    el8.appservice.notifier.notify('Prenatal flowsheet deleted.');
                    if (successCallbackFn) { successCallbackFn(item); }
                }
            });
        }
    });
    
    that.getSummary = function() {
        return el8.template.ptdata.prenatalFlowsheets.patientSummary({
            flowsheets: that.all().map(el8.model.toSoyMapFn)
        }).el8_unescape();
    };

    return that;
})();


